import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import FilterExposedHeader from '../FilterExposedHeader';
import { Filter, FilterFrame, FilterSelection } from '../Filters.style';
import RadioButtonSelector from '../../RadioButtonSelector';
import { SortMethodsTypes } from '../../../types';
import { ExposedFiltersTypes } from '../../../constants/initialFilters';
import useAnimations from '../../../hooks/Animations/useAnimations';
import { selectVehiclesOneGraph, setSortBy } from '../../../redux/vehiclesReducer';

interface SortByMobileTypes {
  sortMethods: SortMethodsTypes;
  openedFiltersList: ExposedFiltersTypes;
  filterType: string;
  handleExposeFilter: (arg: string) => void;
}

const SortByMobile: React.FC<SortByMobileTypes> = ({
  sortMethods,
  openedFiltersList,
  filterType,
  handleExposeFilter,
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { sortBy } = useSelector(selectVehiclesOneGraph);

  const selectedSort = useMemo(() => {
    const selectedSortLabel = sortMethods[sortBy.value as keyof typeof sortMethods]?.label;
    return [...selectedSortLabel];
  }, [sortBy.value, sortMethods]);

  const showFilter = openedFiltersList[filterType];

  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(showFilter);

  return (
    <Filter>
      <FilterExposedHeader
        filterType={filterType}
        selectedFilterLabels={selectedSort}
        handleExposeFilter={handleExposeFilter}
        openedFiltersList={openedFiltersList}
      />
      {dropdownAnimation(
        (props, item) =>
          item && (
            <FilterSelection style={props}>
              <FilterFrame style={filtersAccordianAnimation}>
                <RadioButtonSelector
                  options={sortMethods}
                  value={sortBy.value}
                  onChange={(_isNonAudi, newValue) => {
                    const sortId = sortMethods[newValue as keyof typeof sortMethods]?.id;
                    const sortDirection =
                      sortMethods[newValue as keyof typeof sortMethods]?.direction;
                    const sortToUpload = {
                      id: sortId,
                      direction: sortDirection,
                      value: newValue,
                    };
                    dispatch(setSortBy(sortToUpload));
                  }}
                  name="sort-by-mobile-options"
                />
              </FilterFrame>
            </FilterSelection>
          ),
      )}
    </Filter>
  );
};

export default SortByMobile;
